<div class="flex mx-2">
  <div *ngFor="let item of items; let i = index" class="step" [class.active]="i === step" [class.done]="i < step">
    <div class="circle"></div>
    <div class="line"></div>
  </div>
</div>
<div class="flex justify-between">
  <p *ngFor="let item of items; let i = index" class="overline-o4 grey-300" [class.active]="i === step" [class.done]="i < step">{{item | translate }}</p>
</div>
